module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/error-page/error-page.component.sass
// module id = ./src/app/common/error-page/error-page.component.sass
// module chunks = main